<template>
  <div v-if='loading'>
    <oil-form
        :title='formTitle.toUpperCase()'
        :keys='keys'
        :items='empowerment'
        :createForm='!id'
        @ClosedLimitInTonnes='setTonnes'
        @ClosedLimitInLiters='setLitres'
        :formCallback='formCallback'
    >
      <template v-slot:Company.Id='{rules,input}'>
        <v-autocomplete
            :items='buyers$'
            v-stream:keyup.native='searchCompany$'
            hide-no-data
            class='z-index'
            clearable
            :rules='[...rules]'
            dense
            :disabled='!input.isEdit'
            outlined
            @change='changeBuyer'
            hide-selected
            :value='empowerment.Company'
            item-text='CompanyName'
            label='Выбрать покупателя'
            return-object
        ></v-autocomplete>
      </template>

      <template v-slot:RemainingVolumeLiters>
        <v-text-field
            label='Остаток в литрах'
            background-color='#709b60'
            v-model='empowerment.RemainingVolumeLiters'
            disabled
            outlined
            dense
        >
        </v-text-field>

      </template>


      <template v-slot:RemainingVolumeTonnes>
        <v-text-field
            label='Остаток в тоннах'
            color='white'
            background-color='#709b60'
            v-model='empowerment.RemainingVolumeTonnes'
            disabled
            outlined
            dense
        >
        </v-text-field>
      </template>

      <template v-slot:ClosedLimitInTonnes='{input}'>
        <v-text-field
            label='Ограничение в тоннах'
            v-model='empowerment.ClosedLimitInTonnes'
            type='number'
            :disabled='!input.isEdit'
            :readonly='(empowerment.ClosedLimitInLiters > 0) || id ||agree ? true : false'
            outlined
            dense
        >

        </v-text-field>
      </template>
      <template v-slot:ClosedLimitInLiters='{input}'>
        <v-text-field
            label='Ограничение в литрах'
            v-model='empowerment.ClosedLimitInLiters'
            type='number'
            :disabled='!input.isEdit'
            :readonly='(empowerment.ClosedLimitInTonnes > 0) || id || agree? true : false'
            outlined
            dense
        >

        </v-text-field>
      </template>
      <template v-slot:File='{input}'>
        <v-row>
          <v-col class='pd' cols='12' sm='6' md='6'>
            <v-file-input
                show-size
                outlined
                dense
                :disabled='!input.isEdit'
                :label="empowerment.Attachment ? empowerment.Attachment.Name : 'загрузить файл'"
                @change='selectFile'
            />
          </v-col>
          <v-col class='pd' cols='12' sm='3' md='3'>
            <v-btn small :disabled='!fileStream.file  || !input.isEdit' @click='upload'>
              загрузить
            </v-btn>
          </v-col>
          <v-col class='pd' cols='12' sm='3' md='3'>
            <v-btn :disabled='!empowerment.Attachment  || !input.isEdit' small @click='dow'>
              скачать
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:File2='{input}' disabled>
        <v-row>
          <v-col class='pd' cols='12' sm='6' md='6' disabled>
            <v-file-input
                show-size
                outlined
                dense
                :disabled='!input.isEdit'
                :label="label"
                @change='selectFile2'
            />
          </v-col>
          <v-col class='pd' cols='12' sm='3' md='3'>
            <v-btn small :disabled='!fileStream2.file  || !input.isEdit' @click='upload2'>
              загрузить
            </v-btn>
          </v-col>
          <v-col class='pd' cols='12' sm='3' md='3'>
            <v-btn :disabled='!empowerment.Attachment2 || !input.isEdit' small @click='dow2'>
              скачать
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </oil-form>
    <v-row justify='center' v-if='!id'>
      <v-dialog
          v-model='dialog'
          persistent
          max-width='290'
      >
        <v-card class='py-4'>
          <v-card-text>
            Вы действительно хотите сохранить?, проверьте пожалуйста количество потом изменить не возможно!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color='green darken-1'
                text
                @click='agre'
            >
              Да
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color='green darken-1'
                text
                @click='dialog = false'
            >
              Нет
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { companiesService } from '@/services/CompaniesService'
import { empowermentService } from '@/services/EmpowermentService'
import { form } from '@/pages/setting/empowerment_create.json'
import { fileService } from '@/services/FileNextNumberService'
import { coreApi } from '@/services/core'
import VueCookies from 'vue-cookies'
import { debounceTime, distinctUntilChanged, filter, pluck, switchMap } from 'rxjs/operators'

export default {
  props: {
    id: String
  },
  components: {
    OilForm: () => import('@/components/helper/oil.form.vue')
  },
  data: () => ({
    empowerment: {
      Attachment: {},
      Attachment2: {},
      Company: {},
      ContractNumber: '',
      EmpowermentFullName: '',
      EndDate: '',
      Number: '',
      StartDate: '',
      Status: '',
      PassportNumber: ''
    },
    token: VueCookies.get('token'),
    formTitle: 'СОЗДАТЬ ДОВЕРЕННОСТЬ',
    keys: form.keys,
    fileStream: {
      file: null,
      id: null
    },
    dialog: false,
    agree: false,
    fileStream2: {
      file: null,
      id: null
    },

    readonlyData1: false,
    readonlyData2: false,
    readonlyTonne: false,
    readonlyLitre: false,

    label: 'загрузить файл',
    loading: false
  }),
  comments: {
    DatePicker: () => import('~/components/helper/form/oil.date.picker')
  },
  domStreams: ['searchCompany$', 'searchContract$'],
  subscriptions() {
    return {
      buyers$: this.searchCompany$.pipe(
          pluck('event', 'target', 'value'),
          debounceTime(200),
          filter(value => value.length > 2),
          debounceTime(100),
          distinctUntilChanged(),
          switchMap(query => coreApi.get(`company/search/name?pattern=${query}`)),
          pluck('data')
      )
    }
  },
  async created() {

    const companies = await companiesService.getAll()
    this.buyers$ = companies.data
    if (this.id) {
      this.formTitle = 'ДОВЕРЕННОСТЬ'
      const emp = await empowermentService.getById(this.id)
      this.empowerment = emp.data
      console.log(emp.data)
      this.label = emp.data?.Attachment2?.Name ? emp.data.Attachment2.Name : 'загрузить файл'

      this.setLitres(this.empowerment.ClosedLimitInLiters)
      this.setTonnes(this.empowerment.ClosedLimitInTonnes)
    }


    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? empowermentService.update : empowermentService.create
    },
    message(){
      return this.id ? 'доверенность удачно изменен' : 'доверенность удачно создан'
    }
  },
  methods: {
    async formCallback(data,input,form,func) {
      this.dialog = true
      if (this.agree || this.id) {
        try {
          const emp = await this.storeType(data)
          this.$notify({
            group: 'mgs',
            type: 'success',
            title: this.message
          })
          if (!emp.data) {
            return
          }

          await this.$router.back()
        } catch (e) {
          alert('Что-то пошло не так')
        }
      }

    },
    async changeBuyer(buyer) {
      if (!buyer) return
      this.empowerment.Company = buyer
    },
    async selectFile(fl) {
      const id = this.empowerment.Attachment?.Id
      if (id && fl) {
        this.fileStream.file = fl
        this.fileStream.id = id
      } else if (!id && fl) {
        const file = await fileService.generateId()
        this.fileStream.id = file.data.Id
        this.fileStream.file = fl
      } else if (!id && !fl) {
        this.fileStream.file = null
        this.fileStream.id = null
      }
    },
    async agre() {
      this.agree = true
      this.dialog = false
      this.formCallback(this.empowerment)
    },
    async selectFile2(fl) {
      const id = this.empowerment.Attachment2?.Id
      if (id && fl) {
        this.fileStream2.file = fl
        this.fileStream2.id = id
      } else if (!id && fl) {
        const file = await fileService.generateId()
        this.fileStream2.id = file.data.Id
        this.fileStream2.file = fl
      } else if (!id && !fl) {
        this.fileStream2.file = null
        this.fileStream2.id = null
      }
    },
    async upload() {
      const attachmentId = this.fileStream.id
      const file = this.fileStream.file
      if (file && attachmentId) {
        const res = await fileService.upload(attachmentId, file)
        this.empowerment.Attachment = res.data
        this.empowerment.Attachment.Id = attachmentId
        if (this.id || this.empowerment.Id) {
          await empowermentService.update(this.empowerment)
        }
        this.fileStream.file = null
        this.fileStream.id = null
      }
    },
    async upload2() {
      const attachmentId = this.fileStream2.id
      const file = this.fileStream2.file
      if (file && attachmentId) {
        const res = await fileService.upload(attachmentId, file)
        this.empowerment.Attachment2 = res.data
        this.empowerment.Attachment2.Id = attachmentId
        if (this.id || this.empowerment.Id) {
          await empowermentService.update(this.empowerment)
        }
        this.fileStream2.file = null
        this.fileStream2.id = null
      }
    },
    async dow() {
      const id = this.empowerment?.Attachment?.Id
      if (id) {
        await this.showMePdf(`file/download`, id)
      }
    },
    async dow2() {
      const id = this.empowerment?.Attachment2?.Id
      if (id) {
        await this.showMePdf(`file/download`, id)
      }
    },

    setTonnes(tonne) {
      if (tonne > 0) {
        this.empowerment.ClosedLimitInLiters = null
        this.keys.ClosedLimitInLiters.attrs.readonly = true
        return
      }
      this.keys.ClosedLimitInLiters.attrs.readonly = false


    },
    setLitres(litre) {

      if (litre > 0) {
        this.empowerment.ClosedLimitInTonnes = null
        this.keys.ClosedLimitInTonnes.attrs.readonly = true
        return
      }
      this.keys.ClosedLimitInTonnes.attrs.readonly = false
    }
  },
  changeLitre() {
    alert('warning')
  },
  watch: {}

}
</script>

<style>
.pd {
  padding: 0 6% 0 2% !important;
}
</style>
